import { Helmet } from 'react-helmet-async';

import useWhiteLabel from "../../hooks/useWhiteLabel";

const WhiteLabel = () => {
  
    const {isWhiteLabel, appName, appPrimaryColor, favicon, logo192, manifest, setInstColors} = useWhiteLabel();

    if (isWhiteLabel && appPrimaryColor) {
        setInstColors(appPrimaryColor);
    }

    return (
        <Helmet>
            <title>{appName}</title>
            <link rel="icon" type="image/png" href={favicon} />
            <link rel="apple-touch-icon" href={logo192} />
            <link rel="manifest" href={manifest} />
        </Helmet>
    );

}

export default WhiteLabel;
